// Layer 3 — whole-row scroll sizing for the Advisory stage bodies (polish.P28c
// r1 / r1b): a scrolling list's bottom edge falls on a row boundary, so no row
// is cut mid-text. Pure: the hook in `WholeRowScroll.ts` measures, this decides.

/** How a scroll body is sized: a fixed number of whole rows (the ledger holds
 *  comp A's three), or as many whole rows as a pixel budget allows. */
export type WholeRowFit = { rows: number } | { budgetPx: number; minRows: number };

/**
 * The scroll height, ending on a row boundary so no row is cut by the body's
 * bottom edge. `rowTops` are each row's top inside the scroll content (the
 * first is 0 for a plain list, the sticky head's height for a table) and
 * `listHeight` the full content height; the result is the top of the first row
 * that does not fit, or null when every row fits.
 */
export function wholeRowScrollHeight(rowTops: readonly number[], listHeight: number, fit: WholeRowFit): number | null {
  const boundary = (count: number) => (count < rowTops.length ? rowTops[count]! : null);
  if ('rows' in fit) return boundary(fit.rows);
  if (listHeight <= fit.budgetPx) return null;
  let count = Math.min(fit.minRows, rowTops.length);
  while (count + 1 < rowTops.length && rowTops[count + 1]! <= fit.budgetPx) count += 1;
  return boundary(count);
}
